function cleanText(html) {
  const div = document.createElement("div");
  div.innerHTML = html || "";
  return div.textContent || div.innerText || "";
}

document.addEventListener("click", async function (e) {
  const closeBtn = e.target.closest("[data-quick-view-close]");
  const quickBtn = e.target.closest(".quick-view-icon-btn");
  const addBtn = e.target.closest(".quick-view-add");
  const thumbBtn = e.target.closest(".qv-thumb");

  if (closeBtn) {
    const modal = document.querySelector("#quick-view-modal");
    if (modal) modal.hidden = true;
    document.body.style.overflow = "";
    return;
  }

  if (thumbBtn) {
    const mainImg = document.querySelector("#qv-main-img");
    const img = thumbBtn.querySelector("img");

    if (mainImg && img) {
      mainImg.src = img.src;
      document.querySelectorAll(".qv-thumb").forEach(btn => btn.classList.remove("active"));
      thumbBtn.classList.add("active");
    }
    return;
  }

  if (addBtn) {
    e.preventDefault();
    e.stopPropagation();

    addBtn.disabled = true;
    addBtn.textContent = "Adding...";

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          id: Number(addBtn.dataset.variantId),
          quantity: 1
        })
      });

      if (!res.ok) throw new Error("Add failed");
      window.location.href = "/cart";
    } catch (error) {
      addBtn.disabled = false;
      addBtn.textContent = "Add to cart";
      alert("Product add nahi ho paaya. Please try again.");
    }

    return;
  }

  if (!quickBtn) return;

  e.preventDefault();

  const handle = quickBtn.dataset.productHandle;
  const modal = document.querySelector("#quick-view-modal");
  const body = document.querySelector("#quick-view-body");

  if (!handle || !modal || !body) return;

  modal.hidden = false;
  document.body.style.overflow = "hidden";
  body.innerHTML = `<div class="quick-view-loading">Loading...</div>`;

  try {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error("Product fetch failed");

    const product = await res.json();
    const firstVariant = product.variants.find(v => v.available) || product.variants[0];

    const salePrice = firstVariant.price / 100;
    const mrp = firstVariant.compare_at_price ? firstVariant.compare_at_price / 100 : null;

    const images = product.images && product.images.length ? product.images : [product.featured_image];
    const description = product.description || "";

    const thumbnails = images.map((img, index) => `
      <button type="button" class="qv-thumb ${index === 0 ? "active" : ""}">
        <img src="${img}" alt="${product.title}">
      </button>
    `).join("");

    body.innerHTML = `
      <div class="quick-view-product">
        <div class="quick-view-gallery">
          <div class="quick-view-thumbs">${thumbnails}</div>

          <div class="quick-view-image">
            <img id="qv-main-img" src="${product.featured_image}" alt="${product.title}">
          </div>
        </div>

        <div class="quick-view-info">
          <h2 class="quick-view-title">${product.title}</h2>

          <div class="quick-view-price-wrap">
            <span class="quick-view-sale-price">Rs. ${salePrice.toLocaleString("en-IN")} INR</span>
            ${mrp && mrp > salePrice ? `<span class="quick-view-mrp">Rs. ${mrp.toLocaleString("en-IN")} INR</span>` : ""}
          </div>

          <div class="quick-view-description">
            ${description}
          </div>

          <button
            type="button"
            class="quick-view-add"
            data-variant-id="${firstVariant.id}"
            ${firstVariant.available ? "" : "disabled"}
          >
            ${firstVariant.available ? "Add to cart" : "Sold out"}
          </button>

          <a href="/products/${handle}" class="quick-view-full-link">
            View full product
          </a>
        </div>
      </div>
    `;
  } catch (error) {
    body.innerHTML = `<p>Product load nahi ho paaya. Please try again.</p>`;
  }
});

document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    const modal = document.querySelector("#quick-view-modal");
    if (modal && !modal.hidden) {
      modal.hidden = true;
      document.body.style.overflow = "";
    }
  }
});